<template>
  <button
    type="button"
    class="ai-visibility-icon-button"
    :class="`ai-visibility-icon-button--${variant}`"
    :aria-label="ariaLabel"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <i class="material-icons-outlined" v-if="isLeadingIcon">{{ icon }}</i>
    <span v-if="label">{{ label }}</span>
    <i class="material-icons-outlined" v-if="!isLeadingIcon">{{ icon }}</i>
  </button>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    icon: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
    },
    label: {
      type: String,
      default: '',
    },
    isLeadingIcon: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-icon-button {
  display: inline-flex;
  width: fit-content;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 6px;
  background: var(--v-cardBg-base);
  cursor: pointer;
  padding: 10px;
  gap: 10px;

  span {
    color: var(--v-blackColor-base);
    font-size: 14px;
    font-weight: 600;
  }
}

.ai-visibility-icon-button i {
  font-size: 20px;
  color: var(--v-gray12Color-base);
}

.ai-visibility-icon-button:disabled {
  cursor: default;
  opacity: 0.55;
}

</style>
